import PartnerLogo from './PartnerLogo';
import fusionConstant from './FusionConstant';
import Introductions from './Introductions';
import RegisterStep from './RegisterStep';
import CalvertFamily from './CalvertFamily';
import FusionLandingPaper from './FusionLandingPaper';
import FusionConstant from './FusionConstant';
import { ADOBE_CONSTANTS } from '../../../../../shared/js/constants';
import { RX } from '../../../constants/rx';
import LandingModal from '../LandingModal';
import LandingMessage from '../LandingMessage';

const { flex } = window;
const { React } = flex.lib;
const { adobe } = flex.tracking;
const { loader } = flex.components;

function Landing({ appContext, landing = {} }) {
    React.useEffect(() => {
        const { orgId, code } = appContext.app;

        flex.trigger(RX.LANDING.GET_PUBLIC_CONTENT_TEMPLATES, orgId, code);

        adobe.sendPageView({ signature: ADOBE_CONSTANTS.FIREBALL_SIGNATURE });
    }, []);

    const onLoginClick = () => {
        adobe.sendCustomEvent({
            customClickName: 'landing:login',
            signature: ADOBE_CONSTANTS.FIREBALL_SIGNATURE
        });

        flex.redirect('/sso');
    };

    if (flex.isBusy(RX.LANDING.GET_PUBLIC_CONTENT_TEMPLATES)) {
        return loader;
    }

    const { isModalOpened = false, modalTemplate = {}, messageTemplate = {} } = landing;

    const { content: modalContent } = modalTemplate;
    const { content: messageContent } = messageTemplate;

    return (
        <div className="custom-landing container" style={{ textAlign: 'center' }}>
            {isModalOpened && <LandingModal content={modalContent} />}
            <div className="fusion-landing">
                <div className="fusion-landing__logo">
                    <img src={fusionConstant.FusionLandingLogo} alt="Fusion" width="100%" />
                </div>
                <h1 className="fusion-landing__title">
                    <strong>{fusionConstant.FusionLandingTitle}</strong>
                </h1>
                <h3 className="fusion-landing__subtitle">{fusionConstant.FusionLandingSubTitle}</h3>
                {messageContent && <LandingMessage content={messageContent} />}
                <FusionLandingPaper />
                <button className="btn fusion-landing__btn" onClick={onLoginClick}>
                    {flex.text('UX_LOGIN_ACT_DEALER_LOGIN', 'Dealer Login')}
                </button>
                <div className="fusion-landing__power-by">
                    <span className="fusion-landing__power-by__text">
                        {FusionConstant.powerBy.header}
                    </span>
                    <PartnerLogo logoList={fusionConstant.powerBy.itemList} />
                </div>
            </div>
            <Introductions />
            <RegisterStep />
            <CalvertFamily />
        </div>
    );
}

module.exports = Landing;
